import { GenRequestType } from '../constants/common';

// @ts-nocheck
export const getCleanText = (text: string): string =>
  text
    .replace(/^#{1,6}\s+/gm, '') // remove # but keep line breaks
    .replace(/\*\*(.*?)\*\*/g, '$1') // bold
    .replace(/\*(.*?)\*/g, '$1') // italic
    .replace(/`(.*?)`/g, '$1') // code
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // links
    .replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1') // images
    .replace(/^---+$/gm, '') // horizontal lines
    .replace(/\|/g, ' ') // tables
    .replace(/[ \t]+/g, ' ') // multiple spaces
    .trim();

export const getRequestType = (
  isUserSubscribed: boolean,
  freePremiumGenerationsAttemptsCount: number
) => {
  if (isUserSubscribed || freePremiumGenerationsAttemptsCount > 0) {
    return GenRequestType.SMART;
  }

  return GenRequestType.SIMPLE;
};
